// Utility aliases from Umbraco
export const TOP_SELLING = 'topSelling'
export const FOR_MANUFACTURER = 'forManufacturer'
export const CATEGORY_PATH = 'categoryPath'
export const BRAND = 'brand'
export const PRODUCT_LINES = 'productLines'
export const BRAND_AND_PRODUCT_LINES = 'brandAndProductLines'
export const BY_IDS = 'byIDs'
export const BY_ACTIVITY_ID = 'byActivityID'
